<template>
  <div class="p-col-12">
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <Dialog
      :visible.sync="show"
      :style="{ width: $isMobile() ? '100vw' : '40vw' }"
      :header="`Marcar Intervenção - Pat ${pat?.pat_id}`"
      :modal="true"
      :closable="false"
    >
      <div class="card">
        <form
          name="MarkInterventionForm"
          class="p-col-12"
          @submit.prevent="markIntervention"
          style="min-height: 20vh"
        >
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-12 p-mt-2">
              <span class="p-float-label">
                <Dropdown
                  v-model="respTechnical"
                  name="respTechnical"
                  v-validate="'required'"
                  v-bind:class="['form-control']"
                  :options="technicals"
                  :optionLabel="getUserSearchLabel"
                  :optionValue="'id'"
                  :dataKey="'id'"
                  :filter="true"
                  :required="true"
                >
                  <template #option="slotProps">
                    {{ slotProps.option.username }}
                    {{
                      slotProps.option.office != ""
                        ? "(" + slotProps.option.office + ")"
                        : ""
                    }}
                  </template>
                </Dropdown>
                <label for="respTechnical">Técnico</label>
              </span>
              <small
                v-if="errors.has('respTechnical')"
                class="p-error"
                role="alert"
                >Técnico é obrigatório</small
              >
            </div>

            <div class="p-field p-col-12 p-md-4 p-mt-2">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <i class="pi pi-calendar"></i>
                </span>
                <span class="p-float-label">
                  <v-date-picker
                    name="day"
                    id="day"
                    v-model="day"
                    v-validate="'required'"
                    :min-date="new Date()"
                    :masks="{
                      input: 'YYYY-MM-DD',
                    }"
                  >
                    <template v-slot="{ inputValue, inputEvents }">
                      <span class="p-float-label">
                        <input
                          v-bind:class="[
                            'form-control',
                            'p-inputtext',
                            'p-component',
                            'p-filled',
                          ]"
                          :value="inputValue"
                          v-on="inputEvents"
                          autocomplete="off"
                        />
                        <label for="day">Dia</label>
                      </span>
                    </template>
                  </v-date-picker>
                </span>
              </div>
              <small v-if="errors.has('day')" class="p-error" role="alert"
                >Dia é obrigatório</small
              >
            </div>

            <div class="p-field p-col-12 p-md-4 p-mt-2">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <i class="pi pi-clock"></i>
                </span>
                <span class="p-float-label">
                  <Calendar
                    id="start"
                    ref="start"
                    v-model="start"
                    v-validate="'required|date_format:H:mm'"
                    v-bind:inputClass="['form-control']"
                    :timeOnly="true"
                    :stepMinute="15"
                    name="start"
                    inputStyle="min-width: 100%"
                    autocomplete="off"
                  />
                  <label for="inputtext">Hora de início</label>
                </span>
              </div>
              <small v-if="errors.has('start')" class="p-error" role="alert"
                >Hora de início é obrigatório</small
              >
            </div>

            <div class="p-field p-col-12 p-md-4 p-mt-2">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <i class="pi pi-clock"></i>
                </span>
                <span class="p-float-label">
                  <Calendar
                    id="end"
                    v-model="end"
                    v-validate="'required|date_format:H:mm|after_start'"
                    v-bind:inputClass="['form-control']"
                    :timeOnly="true"
                    :stepMinute="15"
                    name="end"
                    inputStyle="min-width: 100%"
                    autocomplete="off"
                  />
                  <label for="inputtext">Hora de fim</label>
                </span>
              </div>
              <small v-if="errors.has('end')" class="p-error" role="alert"
                >Hora de fim tem que ser posterior à de início</small
              >
            </div>
            <div class="p-field p-col-12 p-md-12 p-mt-2">
              <span class="p-float-label">
                <Textarea
                  id="note"
                  name="note"
                  :autoResize="true"
                  v-model="note"
                  v-bind:class="[
                    'p-inputtextarea',
                    'p-inputtext',
                    'p-component',
                  ]"
                  rows="5"
                />
                <label for="inputtext">Nota</label>
              </span>
            </div>
          </div>
        </form>
      </div>
      <template #footer>
        <Button
          :label="'Guardar'"
          icon="pi pi-save"
          class="p-button-success"
          @click="markIntervention"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="cancel"
        />
      </template>
    </Dialog>
  </div>
</template>
<script>
import taskService from "@/services/task.service";
import { getOnlyDate, getOnlyTime } from "@/helpers/helpers";
import VeeValidate from "vee-validate";
export default {
  name: "PatMarkIntervention",
  props: {
    pat: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    patId() {
      this.reset();
    },
  },
  data() {
    return {
      technicals: [],
      moreTechnicals: [],
      patsList: [],
      respTechnical: null,
      day: null,
      start: null,
      end: null,
      note: "",
    };
  },
  beforeMount() {
    Object.keys(this.$store.state.auth.user.supportUsers).forEach((office) => {
      this.technicals = this.technicals.concat(
        this.$store.state.auth.user.supportUsers[office]
      );
    });
  },
  async created() {
    VeeValidate.Validator.extend("after_start", {
      validate: () =>
        new Promise((resolve) => {
          let day = new Date();
          if (!(this.day instanceof Date)) {
            day = new Date(this.day);
          } else {
            day = this.day;
          }

          if (!(this.start instanceof Date)) {
            let newStart = new Date();
            newStart.setSeconds(0);
            newStart.setHours(this.start.split(":")[0]);
            newStart.setMinutes(this.start.split(":")[1]);
            this.start = newStart;
          }
          if (!(this.end instanceof Date)) {
            let newEnd = new Date();
            newEnd.setSeconds(0);
            newEnd.setHours(this.end.split(":")[0]);
            newEnd.setMinutes(this.end.split(":")[1]);
            this.end = newEnd;
          }

          this.start.setFullYear(
            day.getFullYear(),
            day.getMonth(),
            day.getDate()
          );
          this.end.setFullYear(
            day.getFullYear(),
            day.getMonth(),
            day.getDate()
          );
          resolve({
            valid: this.end > this.start,
          });
        }),
    });
  },
  methods: {
    reset() {
      this.moreTechnicals = [];
      this.respTechnical = null;
      this.day = null;
      this.start = null;
      this.end = null;
      this.note = "";
      this.note = "";
    },
    getUserSearchLabel(info) {
      return `${info.username} ${info.office != "" ? `(${info.office})` : ""}`;
    },
    cancel() {
      this.reset();
      return this.$emit("close");
    },
    getTecName(id) {
      var technician = this.technicals.find((tec) => tec.id == id);

      return technician.name;
    },
    markIntervention() {
      this.$validator.validateAll().then((isValid) => {
        if (!isValid || !this.day) {
          return;
        }
        let bodyParams = {
          from_support: true,
          pat_number: this.pat.pat_id,
          start: `${getOnlyDate(this.day)} ${getOnlyTime(this.start)}`,
          end: `${getOnlyDate(this.day)} ${getOnlyTime(this.end)}`,
          user_id: this.respTechnical,
          resume: this.note,
        };
        this.$validator.pause();
        this.$validator.reset();
        return taskService.createTask(bodyParams).then((response) => {
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: "Erro ao marcar intervenção",
              detail: "",
              life: 3000,
            });
          }
          this.$toast.add({
            severity: "success",
            summary: `Intervenção marcada com sucesso`,
            detail: ``,
            life: 3000,
          });

          return this.$emit("marked", {
            status: "ok",
            intervention: response,
          });
        });
      });
    },
  },
};
</script>
